import { Api } from "./api"

export class GreenGradingSettingApi extends Api {
  constructor() {
    super('green_grading_settings', [], { prefix: 'green_gradings'})
  }
}
